var React = require('react');

function LeasingIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H17.0537V11.9758L14.7013 16.0864L14.6944 16.0824L14.4571 20.2177L17.0537 18.496V22H0V0ZM2.51612 2.25639H14.5376V3.94869H2.51612V2.25639ZM14.5376 5.64101H2.51612V7.33332H14.5376V5.64101ZM2.51612 9.02561H14.5376V10.7179H2.51612V9.02561ZM14.5376 12.4102H2.51612V14.1025H14.5376V12.4102Z","fill":"white","key":0}),React.createElement("path",{"d":"M20.8321 7.61836L23 9.03792L17.556 17.4999L17.5604 17.5027L15.0667 18.9744L15.3836 16.0773L15.3882 16.0803L20.8321 7.61836Z","fill":"white","key":1})]);
}

LeasingIcon.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = LeasingIcon;

LeasingIcon.default = LeasingIcon;
